import { orderBy, filter, forEach, isEmpty } from 'lodash'
import { sanitizeAndLower } from '../helpers/strings'

export default {
    data () {
        return {
            listConfig: {
                filter: '',
                orderProp: 'name',
                orderDir: 'asc',
                columns: ['name', 'color']
            }
        }
    },
    computed: {
        list () {
            return this.doOrderList(this.records)
        }
    },
    methods: {
        doOrderList (records) {
            let orderProp = this.listConfig.orderProp
            const search = sanitizeAndLower(this.listConfig.filter)
            const list = orderBy(records, [(record) => (typeof record[orderProp] === 'string') ? record[orderProp].toLowerCase() : record[orderProp]], [ this.listConfig.orderDir ])

            if (isEmpty(search))
                return list

            return filter(list, response => {
                let result = false
                forEach(this.listConfig.columns, column => {
                    if (sanitizeAndLower(response[column]).indexOf(search) >= 0)
                        result = true
                })
                return result
            })
        },
        setOrder (property) {
            this.listConfig.orderProp = property
            this.listConfig.orderDir = (this.listConfig.orderDir === 'asc') ? 'desc' : 'asc'
        },
        isOrderedColumn (column) {
            if (this.listConfig.orderProp !== column)
                return

            return this.listConfig.orderDir
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/table-filters.js